export const baseUrl = '/company-account-categories'
